module.exports = __webpack_public_path__ + "static/media/bracelet2.ee3d960b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/bonus/liberty/bracelet2.jpg
// module id = 59
// module chunks = 0